module.exports = __webpack_public_path__ + "img/美丽诊所.8521ecf.png";